exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brk-mob{margin-top:-15px}@media (min-width:769px){.brk-banner{height:140px}}@media (max-width:768px){.brk-banner{position:relative}.brk-banner:before{display:block;width:100%;padding-top:38%;position:inherit;content:\"\"}.brk-banner .boxed{position:absolute;top:0;left:0}}", ""]);

// exports
